import React, {useEffect, useState} from "react";
import DsModal from "../_UI/dsModal";
import Form from "../_UI/dsModal/form.module.scss";
import Styles from "./styles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
    getGoogleConnectQr,
    setGoogleAuthenticatorConnectModalStatus,
    setGoogleCode,
    setGoogleCodeFailure
} from "../../store/cabinet/action";
import {useTranslation} from "react-i18next";
import OtpInput from 'react-otp-input';
import {toast} from "react-toastify";




const CabinetGoogleAuthenticatorConnectModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const googleAuthenticatorConnectModalStatus = useSelector((store) => store.cabinet.googleAuthenticatorConnectModalStatus);
    const googleConnectQrStatus = useSelector((store) => store.cabinet.googleConnectQrStatus);
    const googleCodeStatusErr = useSelector((store) => store.cabinet.googleCodeStatusErr);



    const [step, setStep] = useState('1');
    const [code, setCode] = useState('');

    const handleChange = (val) => {
        if (googleCodeStatusErr?.otp){
            dispatch(setGoogleCodeFailure(false));
        }
        setCode(val.replace(/\D/g, '').slice(0, 6));
    };

    const submit = () => {
        const toastHandler = () =>{
            toast(`Google 2FA ${t('Подключена')}`);
            closeModal();
        }

        if (code.length === 6) {
            dispatch(setGoogleCode({otp: code}, toastHandler))
        }
    };

    const closeModal = () => {
        dispatch(setGoogleAuthenticatorConnectModalStatus(false));
        setCode('');
        setStep('1');
        if (googleCodeStatusErr?.otp){
            dispatch(setGoogleCodeFailure(false));
        }
    };

    useEffect(() => {
        if (googleAuthenticatorConnectModalStatus && !googleConnectQrStatus){
            dispatch(getGoogleConnectQr());
        }
    }, [googleAuthenticatorConnectModalStatus, googleConnectQrStatus, dispatch]);

    const copySecret = () => {
        if (googleConnectQrStatus?.secret) {
            navigator.clipboard.writeText(googleConnectQrStatus?.secret);
            toast(`${t('Скопировано')}!`);
        }
    };

    return (
        <DsModal
            open={googleAuthenticatorConnectModalStatus}
            onClose={closeModal}
            size="sm"
            title={step === '1' ? t('Сканируйте QR-код') : t('Введите код подтверждения')}
            subtitle={step === '1'
                ? t('Откройте приложение Google Authenticator и добавьте новый аккаунт, отсканировав QR-код')
                : t('Откройте Google Authenticator и введите 6-значный код')}
        >
            <div className={Styles.steps}>
                <span className={Styles.stepActive}/>
                <span className={step === '2' ? Styles.stepActive : ''}/>
            </div>

            {step === '1' ? (
                <>
                    <div className={Styles.qrWrap}>
                        {googleConnectQrStatus?.qr_code_image
                            ? <img src={googleConnectQrStatus?.qr_code_image} alt="qr"/>
                            : <div className={Styles.qrLoad}>{t('Загрузка...')}</div>}
                    </div>
                    <div className={`${Form.noteMuted} ${Form.center}`}>{t('или скопируйте секретный ключ и вставьте его в приложении')}</div>
                    <div className={Styles.secretRow}>
                        <div className={Styles.secret}>{googleConnectQrStatus?.secret || t('Загрузка...')}</div>
                        <button type="button" className={Styles.copyBtn} onClick={copySecret}>{t('Скопировать')}</button>
                    </div>
                    <button type="button" className={Form.btnAccent} onClick={() => setStep('2')}>{t('Далее')}</button>
                </>
            ) : (
                <>
                    <form className={googleCodeStatusErr?.otp ? Form.otpErr : ''} onSubmit={(e) => { e.preventDefault(); submit(); }}>
                        <OtpInput
                            value={code}
                            onChange={handleChange}
                            numInputs={6}
                            shouldAutoFocus
                            renderInput={(inputProps, idx) => (
                                <input
                                    {...inputProps}
                                    key={idx}
                                    inputMode="numeric"
                                    autoComplete="one-time-code"
                                    className={Form.otpBox}
                                />
                            )}
                            containerStyle={Form.otp}
                        />
                    </form>
                    <div className={`${Form.err} ${Form.center}`}>{googleCodeStatusErr?.otp ? t('Код подтверждения введен не верно') : ''}</div>
                    <div className={Form.actions}>
                        <button type="button" className={Form.btnNeutral} onClick={() => setStep('1')}>{t('Назад')}</button>
                        <button
                            type="button"
                            className={`${Form.btnAccent} ${code.length === 6 ? '' : Form.btnDisabled}`}
                            onClick={submit}
                        >
                            {t('Подтвердить')}
                        </button>
                    </div>
                </>
            )}
        </DsModal>
    );
};

export default CabinetGoogleAuthenticatorConnectModal;
